import {
  Currency,
  ExternalBankAccount,
  ExternalBankAccountStatus
} from "@wingspanhq/wingspan-api-sdk";

export const selectorExternalBankAccountInternationalIPReady = (
  externalBankAccount: ExternalBankAccount
) =>
  externalBankAccount.currency === Currency.CAD &&
  externalBankAccount.status !== ExternalBankAccountStatus.REMOVED &&
  externalBankAccount.status !== ExternalBankAccountStatus.FAILED;
